export class ErrorMessageResponse {
  errorCode?: string;
  message?: string;
}
